// frontend-react/src/schemas/customer.schema.js
/**
 * Schemas Zod pour la validation des clients (frontend)
 * Miroir des schemas backend avec format ESM
 */

import { z } from 'zod';

// Types de client autorisés
export const CUSTOMER_TYPES = ['particulier', 'revendeur', 'entreprise'];

// Schema de base pour un client
export const customerBaseSchema = z.object({
  name: z
    .string()
    .min(2, 'Le nom doit contenir au moins 2 caractères')
    .max(255, 'Le nom ne peut pas dépasser 255 caractères')
    .transform((v) => v.trim()),

  phone: z
    .string()
    .regex(/^\+?[0-9]{8,15}$/, 'Numéro de téléphone invalide (8-15 chiffres)')
    .optional()
    .nullable()
    .or(z.literal(''))
    .transform((v) => (v && v.trim() ? v.trim() : null)),

  email: z
    .string()
    .email('Adresse email invalide')
    .max(255, 'Email trop long')
    .optional()
    .nullable()
    .or(z.literal(''))
    .transform((v) => (v && v.trim() ? v.trim().toLowerCase() : null)),

  type: z
    .enum(CUSTOMER_TYPES, {
      errorMap: () => ({ message: `Type invalide. Valeurs acceptées: ${CUSTOMER_TYPES.join(', ')}` }),
    })
    .default('particulier'),

  is_active: z.boolean().default(true),
});

// Schema pour la création d'un client
export const customerCreateSchema = customerBaseSchema.extend({
  name: z
    .string()
    .min(2, 'Le nom est obligatoire (min 2 caractères)')
    .max(255)
    .transform((v) => v.trim()),
});

// Schema pour la mise à jour d'un client (tous les champs optionnels)
export const customerUpdateSchema = customerBaseSchema.partial();

// Fonctions de validation (safe - retournent {success, data, error})
export function validateCustomerCreate(data) {
  return customerCreateSchema.safeParse(data);
}

export function validateCustomerUpdate(data) {
  return customerUpdateSchema.safeParse(data);
}

// Helper pour extraire les erreurs par champ
export function getFieldErrors(result) {
  if (result.success) return {};

  const errors = {};
  for (const issue of result.error.issues) {
    const path = issue.path.join('.');
    if (!errors[path]) {
      errors[path] = issue.message;
    }
  }
  return errors;
}
